import React from 'react';

import { StatusDot } from '@picsio/icons';
import { Icon } from '@picsio/ui';

const masterChannelOption = {
  label: 'Master',
  value: 'master',
  type: 'master',
  icon: (
    <Icon size="md">
      <StatusDot />
    </Icon>
  ),
};

export default masterChannelOption;